import { HttpClient } from '@angular/common/http';
import { Injectable, computed, inject, signal } from '@angular/core';
import { SliderResponse } from '@models/slider/slider-response.model';
import { map } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { Slider } from '@models/slider/slider.model';
@Injectable({
  providedIn: 'root'
})
export class SliderService {
  private readonly http = inject(HttpClient);
  private readonly sliders$ = this.http
    .get<SliderResponse>('slider?page=1&per_page=100')
    .pipe(map(({ sliders }) => sliders.data.filter(slider => slider.status === 'active')));
  protected _sliders = signal<Slider[]>([]);
  public sliders = computed(() => this._sliders());
  getSlider() {
    this.sliders$.subscribe(res => {
      this._sliders.set(res);
    });
  }
}
